import { Component } from "@angular/core";
import moment from "moment-timezone";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOTags } from "src/app/shared/models/oo-tags.model";

@Component({
	selector: "app-item-tag-setup",
	templateUrl: "./item-tag-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ItemTagSetupComponent {
	changesToSave: boolean = false;
	clonedTag: OOTags;

	loaded: boolean = false;

	moment: any = moment;

	tagSelected: OOTags;
	tagSeverities = [
		{
			name: "Blue",
			value: "info",
		},
		{
			name: "Green",
			value: "success",
		},
		{
			name: "Yellow",
			value: "warning",
		},
		{
			name: "Red",
			value: "danger",
		},
	];

	timestamp;
	timezones: any[] = [];

	constructor(public app: AppService, public venueService: OOVenueService) {}

	async newTag() {
		this.tagSelected = new OOTags({
			venueKey: this.venueService.venueKey,
			unsaved: true,
		});
	}

	async saveTag(tag: OOTags) {
		this.venueService.ooTagSave(tag);
	}

	async deleteTag(tag: OOTags) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete this tag?`,
			accept: async () => {
				this.venueService.ooTagDelete(tag);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
